module.exports = __webpack_public_path__ + "static/media/caffe-milano-3.2d02c894.jpg";